
/* Componente per la creazione delle search bar. Implementato l'autocomplite tramite la libreria UI-Material */

import React from 'react';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Grid from '@material-ui/core/Grid';
import '../SearchBar/SearchBar.css'
import { makeStyles } from "@material-ui/core/styles";
import GpsFixedIcon from '@material-ui/icons/GpsFixed';
import { connect } from 'react-redux';
import { Trans } from 'react-i18next';
import { useTranslation } from 'react-i18next';
//import Typography from '@material-ui/core/Typography';
import tplImage from './TPL.svg'
import stradarioImage from './Street.svg'
import aeroporto from './aeroporto.svg'
import porto from './porto.svg'
import train from './train.svg'
import metro from './metro.svg'
import traghetto from './traghetto.svg'
import {  createMuiTheme,ThemeProvider } from '@material-ui/core/styles';
import {changePositionTariffaStart, changepositionStart,changepositionEnd,selectNewMarkerStart, selectNewMarkerEnd,changeNomeFermataStart,changeNomeFermataEnd } from "../../redux";
//import dataJsonFermate from '../SearchBar/puntofermate.json'
//import i18n from 'i18next';
//import L from "leaflet";
import { useLeaflet } from "react-leaflet";
import imageStart from '../../Mappa/ClickOnMap/start.png'

const useStyles = makeStyles(theme => ({
    root: {
      color: 'black'
      },
    inputRoot: {
        color: "#000000",
        backgroundColor: 'trasparent',
        border: '2px',
        borderColor: 'white',
        position: 'relative',
        bottom: '0px',
        left: '2px'


        
    },


  }));
  const theme = createMuiTheme();

  theme.typography.h3 = {
    fontSize: '13px',
    '@media (min-width:600px)': {
      fontSize: '1.5rem',
    },
    [theme.breakpoints.up('md')]: {
      fontSize: '13px',
    },
  };
function SearchBar(props) {
    const inProps = props
    
    const classes = useStyles();
    const [value, setValue] = React.useState('');
    const [inputValue, setInputValue] = React.useState('');
    const [options, setOptions] = React.useState([]);
    const {i18n} = useTranslation();
    const { map } = useLeaflet();


    //funzione per associare a ogni fermata suggerita da geocoding un immagine
    const setImage = (string)=>{
        
        switch (string) {
            case "Aeroporto":
                return <img src={aeroporto} style={{width:'25px',height:'25px'} } alt="fermate"></img>
                
            case "Fermata Autobus":
                return <img src={tplImage} style={{width:'25px',height:'25px'}} alt="stradario"></img>
                
            case "Porto":
                return <img src={porto} style={{width:'25px',height:'25px'}} alt="stradario"></img>
            case "Stazione Ferroviaria":
                return <img src={train} style={{width:'25px',height:'25px'}} alt="stradario"></img> 
            case "Fermata Metropolitana":
                return <img src={metro} style={{width:'25px',height:'25px'}} alt="stradario"></img> 
                case "Traghetto":
                    return <img src={traghetto} style={{width:'25px',height:'25px'}} alt="stradario"></img>
            default:
                return <img src={stradarioImage} style={{width:'25px',height:'25px'}} alt="stradario"></img>
                
        }
    }

        //funzione per trasformare le stringhe delle fermate in coordinate
      function handleClick  ()  {
        
        try {
            inProps.callback2(inProps.stato);
        } catch (error) {
            
        }
        
        
        
       
        //map.fitBounds([coordinate,coordinate], {maxZoom: 15});
        
           // map.fitBounds([coordinate], {maxZoom: 15});
      
        
        /*
        
        
        const coordinate = [inProps.position.position.lat,inProps.position.position.lng]
        */
         //setValue(`(${inProps.stato.lat}, ${inProps.stato.lng})`);
         
         //map.fitBounds([coordinate,coordinate], {maxZoom: 15});
         //map.zoomIn([coordinate,coordinate], {maxZoom: 15})
         };  
         
         //use effect per specificare cosa tornerà nella search bar
         
      React.useEffect(() =>{
        
        try {
            
            //if (/* inProps.stato.description === undefined && */ inProps.nomeFermataStart.nomeFermataStart !== "" && inProps.nomeFermataStart.nomeFermataStart !== undefined ) {
                //setValue({description: inProps.nomeFermataStart.nomeFermataStart/* `(${Number(inProps.stato.lat).toFixed(8)}, ${Number(inProps.stato.lng).toFixed(8)})` */})
            if ( inProps.positionStart.positionStart &&  inProps.positionStart.positionStart !== "" && inProps.positionStart.positionStart !== undefined ) {
                setValue(inProps.positionStart.positionStart)
                inProps.callback(inProps.positionStart.positionStart);  
            }else {
                setValue('')
                setInputValue('')
                inProps.callback(null);  
                setOptions([])
                //setValue( `(${Number(inProps.stato.lat).toFixed(8)}, ${Number(inProps.stato.lng).toFixed(8)})`)
            }
        } catch (error) {
            setValue('')
            setInputValue('')
            inProps.callback(null);  
            setOptions([])            
        }

    },[inProps.positionStart.positionStart]//,[inProps.stato]
    )  
    
    function removeDuplicates(data){
      var a = data.reduce((acc, current) => {
            const x = acc.find(item => item.lat === current.lat && item.lng === current.lng && item.nome === current.nome);
            if (!x) {
              return acc.concat([current]);
            } else {
              return acc;
            }
          }, [])
          return a
    }
//mappatura dei due servizi geocoding e nomnatim
React.useEffect(() => {  
        
    let active = true;
    
    (async () => {
            
        
            if (active && inputValue !== "" && inputValue.length > 2) {
                try {
                    
                    const response = await fetch(`${window.configFile.httpProxy.urlGeocoding}?q=${inputValue}`,
                        {headers: window.tp_headers});
                    
                    const jsonresponse = await response.json();
                    let array = []
                    
                    jsonresponse.data.map(x=>{
                        
                        x["nome"] = i18n.t("Fermata") 
                        x["lng"] = x.lon
                        delete x.lon
                        if(array.length <10) array.push(x)
                        //inProps.changeNomeFermataStart(x.description)
                       
                    })
                    // dataJsonFermate.data.map(x=>{
                    //     x["nome"] = "Fermata"
                    //     x["lng"] = x.stop_lon
                    //     x["lat"] = x.stop_lat
                    //     x.description = x.stop_desc
                    //     x["type"] = x.stop_type
                    //     array.push(x)
                    // })
                    jsonresponse.dataNom.map(x=>{
                        let valore = {
                            type:"Stradario",
                            description: x.display_name,
                            lat: x.lat,
                            lng:x.lon,
                            state : x.address.state,
                            county : x.address.county,
                            town : x.address.village,
                            nome : "Stradario"
                        }
                        if(x.type !== "river" && x.address.city !== undefined ) array.push(valore)
                        //inProps.changeNomeFermataStart(valore.description)
                    })
                    
                    
                    setOptions(removeDuplicates(array)) 
                } catch (error) {
                    
                }
            
        
    }
    })()

    return () => {
        active = false;
       
    };
}, [value, inputValue]);

    return (
        <Autocomplete
        classes={classes}
        style={{ width: 250, color: 'black'}}
        getOptionLabel={(option) => (typeof option === 'string' ? option : option.description)}
        groupBy={(option) => option.nome}
        filterOptions={(x) => x}
        freeSolo
        options={options}
        value={value}
        
        onChange={(event, newValue) => {
           
            //setOptions(newValue ? [newValue, ...options] : [options]);
            setOptions(newValue ? [newValue, ...options] : []);
            inProps.callback(newValue);
            setValue(newValue);
            
        }}
        onInputChange={(event, newInputValue) => {
           
            setInputValue(newInputValue);
            if(newInputValue == ""){
                inProps.callback(null);
                //setOptions([])
                setValue({})
            }
            
        }}
        renderInput={(params) => ( 
            <div className="contenitoreRicerca" >  
                    <div className="boxTitolo" ><Trans>{inProps.titolo}</Trans></div>
                    <div className={'searchContainer'}> 
                            <TextField  placeholder={i18n.t(inProps.placeholder)} {...params} InputLabelProps={{style: {fontSize: 1, color: "gray", position:'relative', bottom:10,left: -40}}} />
                    </div>
                    <button className="localizationButton"  onClick={handleClick} >
                            <GpsFixedIcon fontSize="small"/>
                    </button>
                    <img src={imageStart} alt="Start" className={'searchIcon'}/>            
            </div>
        )}
        renderOption={(option) => {
            
            return (
                
                <Grid className="autocomplete" container alignItems="center" wrap="nowrap" spacing={1}>
                    {setImage(option.type)}
                    <Grid item xs><p className={"textSearch"} >{(!option.comune)?option.description:option.description + ' (' + option.comune +')'}</p></Grid>
                    
                </Grid>
          
            );
        }}
        />
    );
}
const mapStateToProps = state => {
    return {
        position: state.position,
        positionStart: state.positionStart,
        positionEnd: state.positionEnd,
        nomeFermataStart: state.nomeFermataStart,
        nomeFermataEnd:state.nomeFermataEnd,
        positionTariffaStart : state.positionTariffaStart
    }
  }
  const mapDispatchToProps = dispatch => {
    return {
        changepositionStart: (positionStart) => dispatch(changepositionStart(positionStart)),
        changepositionEnd: (positionEnd) => dispatch(changepositionEnd(positionEnd)),
        markerStart: (marker) => dispatch(selectNewMarkerStart(marker)),
        markerEnd: (marker) => dispatch(selectNewMarkerEnd(marker)),
        changeNomeFermataStart: (nomeFermataStart) => dispatch(changeNomeFermataStart(nomeFermataStart)),
        changeNomeFermataEnd: (nomeFermataEnd) => dispatch(changeNomeFermataEnd(nomeFermataEnd)),        
        changePositionTariffaStart:(positionTariffaStart) => dispatch(changePositionTariffaStart(positionTariffaStart)),

    }
  }

export default connect(mapStateToProps,mapDispatchToProps) (SearchBar);